import { render } from "./PrivacyHeaderBar.vue?vue&type=template&id=2cb3981a&ts=true"
import script from "./PrivacyHeaderBar.vue?vue&type=script&lang=ts"
export * from "./PrivacyHeaderBar.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__